import crossSvg from '@/assets/images/cross.svg';
import gbmLogoPng from '@/assets/images/gbm.png';
import articleSvg from '@/assets/images/article.svg';
import googleSvg from '@/assets/images/Google.svg';
import unionSvg from '@/assets/images/union.svg';
import editSvg from '@/assets/images/edit.svg';
import addTimeRangeSvg from '@/assets/images/add_time_range.svg';
import deleteTimeRangeSvg from '@/assets/images/delete_time_range.svg';
import copyToAllSvg from '@/assets/images/copy_to_all.svg';
import copySvg from '@/assets/images/copy.svg';
import shareSvg from '@/assets/images/share.svg';
import toolTipSvg from '@/assets/images/tooltip.svg';
import qrcodeSvg from '@/assets/images/qrcode.svg';
import plusSvg from '@/assets/images/plus.svg';
import minusSvg from '@/assets/images/minus.svg';
import deleteSvg from '@/assets/images/delete.svg';
import addSvg from '@/assets/images/add.svg';
import locationSvg from '@/assets/images/location.svg';
import infoSvg from '@/assets/images/info.svg';
import successCheckSvg from '@/assets/images/success_check.svg';
import garbageDeleteSvg from '@/assets/images/garbage_delete.svg';

import gbmCardSvg1 from '@/assets/images/card_img_1.svg';
import gbmCardSvg2 from '@/assets/images/card_img_2.svg';
import gbmCardSvg3 from '@/assets/images/card_img_3.svg';

import ellipseSvg from '@/assets/images/ellipse.svg';
import filterSvg from '@/assets/images/filter.svg';
import searchSvg from '@/assets/images/search.svg';

import createBrandConnectorSvg from '@/assets/images/connector.svg';
import defineInteractionsSvg from '@/assets/images/define_interactions.svg';
import selectEntryPointsSvg from '@/assets/images/entry_points.svg';
import testLinksSvg from '@/assets/images/test_links.svg';
import verifyConnectorSvg from '@/assets/images/G.svg';
import launchConnectorSvg from '@/assets/images/launch.svg';
import noImagePlaceholderSvg from '@/assets/images/no_image_placeholder.svg';
import lpPhoneLight from '@/assets/images/lp_phone_light.png';
import lpPhoneDark from '@/assets/images/lp_phone_dark.png';

export const appCode = 'ccm';

export const appName = 'lp-le-conversational-connectors-management';

export const SURFACE_ANDROID_WEB = 'SURFACE_ANDROID_WEB';

export const SURFACE_ANDROID_MAPS = 'SURFACE_ANDROID_MAPS';

export const IMAGES = {
  SVG: {
    cross: crossSvg,
    article: articleSvg,
    google: googleSvg,
    ellipse: ellipseSvg,
    filter: filterSvg,
    union: unionSvg,
    edit: editSvg,
    noImagePlaceholder: noImagePlaceholderSvg,
    addTimeRange: addTimeRangeSvg,
    deleteTimeRange: deleteTimeRangeSvg,
    copyToAll: copyToAllSvg,
    copy: copySvg,
    share: shareSvg,
    toolTip: toolTipSvg,
    qrcode: qrcodeSvg,
    search: searchSvg,
    plus: plusSvg,
    minus: minusSvg,
    delete: deleteSvg,
    add: addSvg,
    location: locationSvg,
    info: infoSvg,
    successCheck: successCheckSvg,
    garbageDelete: garbageDeleteSvg,
    GBM: {
      logo: gbmLogoPng,
      conversationPhoneLight: lpPhoneLight,
      conversationPhoneDark: lpPhoneDark,
      cards: [gbmCardSvg1, gbmCardSvg2, gbmCardSvg3],
      stepper: {
        createBrandConnector: createBrandConnectorSvg,
        defineInteractions: defineInteractionsSvg,
        selectEntryPoints: selectEntryPointsSvg,
        testLinks: testLinksSvg,
        verifyConnector: verifyConnectorSvg,
        launchConnector: launchConnectorSvg,
      },
    },
  },
};

export const VIDEOS = {
  features: 'https://www.youtube.com/embed/C_aBjZ9RfVE',
  featuresAuto: 'https://www.youtube.com/embed/C_aBjZ9RfVE?autoplay=1',
  GBMAgents: 'https://www.youtube.com/embed/Rym-GD9kQHU',
  GBMOnboard: 'https://www.youtube.com/embed/oAolbXNZqjU',
};

export const notifierTimers = {
  warning: 10000,
};

export const gbmAccountTypes = {
  PERSONAL: 'PERSONAL',
  ORGANIZATION: 'ORGANIZATION',
  LOCATION_GROUP: 'LOCATION_GROUP',
};

export const entryPoints = {
  LOCATION: 'LOCATION',
  NON_LOCAL: 'NON_LOCAL',
};

export const verificationState = {
  VERIFICATION_STATE_UNSPECIFIED: {
    status: 'Unspecified',
  },
  VERIFICATION_STATE_UNVERIFIED: {
    status: 'Unverified',
  },
  VERIFICATION_STATE_PENDING: {
    status: 'Pending',
  },
  VERIFICATION_STATE_VERIFIED: {
    status: 'Verified',
  },
  VERIFICATION_STATE_SUSPENDED_IN_GMB: {
    status: 'Suspended',
  },
};

export const verificationStatus = {
  VERIFICATION_STATE_UNSPECIFIED: 'VERIFICATION_STATE_UNSPECIFIED',
  VERIFICATION_STATE_UNVERIFIED: 'VERIFICATION_STATE_UNVERIFIED',
  VERIFICATION_STATE_PENDING: 'VERIFICATION_STATE_PENDING',
  VERIFICATION_STATE_VERIFIED: 'VERIFICATION_STATE_VERIFIED',
  VERIFICATION_STATE_SUSPENDED_IN_GMB: 'VERIFICATION_STATE_SUSPENDED_IN_GMB',
};

export const launchStatus = {
  LAUNCH_STATE_UNSPECIFIED: 'LAUNCH_STATE_UNSPECIFIED',
  LAUNCH_STATE_UNLAUNCHED: 'LAUNCH_STATE_UNLAUNCHED',
  LAUNCH_STATE_PENDING: 'LAUNCH_STATE_PENDING',
  LAUNCH_STATE_LAUNCHED: 'LAUNCH_STATE_LAUNCHED',
  LAUNCH_STATE_REJECTED: 'LAUNCH_STATE_REJECTED',
  LAUNCH_STATE_SUSPENDED: 'LAUNCH_STATE_SUSPENDED',
  LAUNCH_STATE_PENDING_UNLAUNCH: 'LAUNCH_STATE_PENDING_UNLAUNCH',
  LAUNCH_STATE_INVALID_IN_GMB: 'LAUNCH_STATE_INVALID_IN_GMB',
};

export const launchState = {
  LAUNCH_STATE_UNSPECIFIED: {
    status: 'Unspecified',
  },
  LAUNCH_STATE_UNLAUNCHED: {
    status: 'Unlaunched',
  },
  LAUNCH_STATE_PENDING: {
    status: 'Pending',
  },
  LAUNCH_STATE_LAUNCHED: {
    status: 'Launched',
  },
  LAUNCH_STATE_REJECTED: {
    status: 'Rejected',
  },
  LAUNCH_STATE_SUSPENDED: {
    status: 'Suspended',
  },
  LAUNCH_STATE_PENDING_UNLAUNCH: {
    status: 'Pending Unlaunch',
  },
  LAUNCH_STATE_INVALID_IN_GMB: {
    status: 'Invalid Launch',
  },
};

export const GBMNotSupportedTimeZones = [
  'Africa/Asmera',
  'America/Fort_Nelson',
  'America/Indianapolis',
  'America/Kralendijk',
  'America/Louisville',
  'America/Lower_Princes',
  'America/Marigot',
  'America/Punta_Arenas',
  'America/St_Barthelemy',
  'Antarctica/McMurdo',
  'Asia/Atyrau',
  'Asia/Barnaul',
  'Asia/Chita',
  'Asia/Qostanay',
  'Asia/Tomsk',
  'Europe/Astrakhan',
  'Europe/Busingen',
  'Europe/Kirov',
  'Europe/Saratov',
  'Europe/Ulyanovsk',
];

export const modalType = {
  DISCARD_CHANGES: 'discardChanges',
  LAUNCH: 'launch',
  COMPLETE: 'complete',
  CONFIRM: 'confirm',
  SUCCESS: 'success',
  SKILL: 'skill',
  VERIFY_AGENT: 'verifyAgent',
  VERIFY_LOCATIONS: 'verifyLocations',
};

export const E164PhoneNumberFormatRegex = /^\+[1-9]\d{9,13}$/;
